import { render } from "./CProduktField.vue?vue&type=template&id=65da7345"
import script from "./CProduktField.vue?vue&type=script&lang=js"
export * from "./CProduktField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__